import request from '@/utils/ajax';

export interface ImgStyle {
  req_id: number;
  req_name: string;
  req_key: string;
  sub_req_key: string;
}
/**
 * 日历信息
 */
export interface ClockinHistory {
  date: string;
  clock_in_cnt?: number;
  clock_in_day?: number;
  clock_in_type?: number;
  create_time?: string;
  uid?: string;
  fix_time?: string;
  id: number | string;
  status: number;
  day: number | string;
}
//获取弹幕
export function reqClockLogList(data: unknown) {
  return request.request({
    url: '/Clockin/getClockInLogList',
    method: 'post',
    data: data,
  });
}
//打卡注册
export function clockIn(data: unknown) {
  return request.request({
    url: '/Clockin/clockIn',
    method: 'post',
    data: data,
  });
}

//获取用户打卡信息
export function reqClockInfoGet() {
  return request.request({
    url: '/Clockin/getClockInInfo',
    method: 'get',
  });
}

//获取礼品订单信息
export function reqOrderInfoGet() {
  return request.request({
    url: '/Clockin/getOrderInfo',
    method: 'post',
  });
}

//完善礼品订单信息
export function reqOrderAdd(data: unknown) {
  return request.request({
    url: '/Clockin/improveOrder',
    method: 'post',
    data: data,
  });
}

//获取用户打卡信息
export function reqExchageToken(data: unknown) {
  return request.request({
    url: '/login/loginByToken',
    method: 'get',
    params: data,
    addToken: false,
  });
}

//预置打卡数据，临时使用
export function clockInTest(data: unknown) {
  return request.request({
    url: '/Clockin/clockInTest',
    method: 'post',
    data: data,
  });
}

//修改勋章类型
export function reqMedalTypeUpdate(data: {
  clock_in_type: string;
  type_val: number;
}) {
  return request.request({
    url: '/clockin/updmedaltypeval',
    method: 'post',
    data: data,
  });
}

//获取AI图片
export function reqAIImg(data: {
  clock_in_url: string;
  req_key: string;
  sub_req_key: string;
}) {
  return request.request({
    url: '/clockin/img2img',
    method: 'post',
    data: data,
    timeout: 20000,
  });
}

//获取风格类型列表
export function reqImgList() {
  return request.request({
    url: '/clockin/getimglist',
    method: 'get',
  });
}

//根据月份获取打卡历史
export function reqClockInHistory(data: {
  mon: string;
  clock_in_type: number;
}) {
  return request.request({
    url: '/clockin/gethisbymon',
    method: 'post',
    data: data,
  });
}

//控制打卡提醒
export function reqUpdateRemind(data: {
  remind_type: number;
  clock_in_type: number;
}) {
  return request.request({
    url: '/clockin/updremindtype',
    method: 'post',
    data: data,
  });
}

//补卡
export function reqFixClockin(data: {
  clock_in_date: string;
  clock_in_url: string;
  clock_in_comment: string;
  clock_in_type: number;
}) {
  return request.request({
    url: '/clockin/fixclockin',
    method: 'post',
    data: data,
  });
}
